import { CallAPI } from "../../apiManager/ApiCall";
import { publicURL } from "../../apiManager/APIConfig";

export const GetPublicCall = async () => {
  try {
    const response = await CallAPI({
      url: publicURL,
      method: "GET",
    });
    return response || {};
  } catch (e) {
    return { status: 400, data: [] };
  }
};

export const UpsertPublicKeyCall = async ({ key, data }) => {
  try {
    const editRes = await CallAPI({
      url: publicURL,
      method: "PUT",
      body: { key, data },
    });
    if (editRes?.status === 200 || editRes?.status === 201) return editRes;
    const missing =
      editRes?.status === 404 ||
      /not found/i.test(String(editRes?.message || ""));
    if (missing) {
      const addRes = await CallAPI({
        url: publicURL,
        method: "POST",
        body: { key, data },
      });
      return addRes || {};
    }
    return editRes || {};
  } catch (e) {
    return { status: 400 };
  }
};
